<div class="toasts">
  <app-toast
    *ngFor="let toast of toastCollection; let index = index"
    [header]="toast.header"
    [description]="toast.description"
    [iconName]="toast.iconName"
    [variant]="toast.type"
    [index]="index"
    (closeToast)="toastClosed($event)"
  ></app-toast>
</div>
